import Layout from '../../internal/Layout.vue'
import CalendarPage from './calendar/calendar.vue'

const CalendarRoutes = {
  component: Layout,
  children: [
    {
      name: 'call',
      path: '/',
      component: CalendarPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default CalendarRoutes
